import React, { Component } from 'react';
import './ListaClientes.css';
import { connect } from 'react-redux';

import { getClientes } from '../../../redux/actions/dataactions';
import { Link } from 'react-router-dom';

import SubirFotoCliente from './SubirFotoCliente';
import PropTypes from 'prop-types';
import EliminarCliente from './EliminarCliente';
import VerPerfil from './VerPerfil';
import DetallesCliente from './DetallesCliente';

import MyButton from '../../../utils/MyButton';
import { FaUsers } from 'react-icons/fa';
import CargarFirmaCliente from './CargarFirmaCliente';
import PlantillaConfig from './PlantillaConfig';

// MUI v5
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export class ListaClientes extends Component {
  state = {
    search: '',         // búsqueda en tiempo real
    searchBy: 'nombre', // 'nombre' | 'ciudad' | 'ccnit'
    sortOrder: 'asc'    // 'asc' | 'desc'
  };

  componentDidMount() {
    this.props.getClientes();
  }

  // Handlers
  handleSearchChange = (e) => this.setState({ search: e.target.value });
  handleSearchByChange = (e) => this.setState({ searchBy: e.target.value });
  handleSortOrderChange = (e) => this.setState({ sortOrder: e.target.value });
  handleClearFilters = () =>
    this.setState({ search: '', searchBy: 'nombre', sortOrder: 'asc' });

  // Utils
  normalizeStr = (str) =>
    (str || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  normalizeDigits = (str) => (str || '').toString().replace(/\D/g, '');

  render() {
    const { clientes = [], loading } = this.props.data;
    const { search, searchBy, sortOrder } = this.state;

    // 1) Filtrar en tiempo real según campo
    const hasQuery = (search || '').trim().length > 0;
    const filtered = !hasQuery
      ? [...clientes]
      : clientes.filter((c) => {
        if (searchBy === 'ccnit') {
          return this.normalizeDigits(c?.ccnit).includes(this.normalizeDigits(search));
        }
        if (searchBy === 'ciudad') {
          return this.normalizeStr(c?.ciudad).includes(this.normalizeStr(search));
        }
        // default: nombre
        return this.normalizeStr(c?.nombre).includes(this.normalizeStr(search));
      });

    // 2) Orden por nombre (A–Z / Z–A), acento-insensible
    const clientesList = filtered.sort(
      (a, b) =>
        (a?.nombre || '').localeCompare(b?.nombre || '', 'es', { sensitivity: 'base' }) *
        (sortOrder === 'asc' ? 1 : -1)
    );

    let mapeoclientes = !loading ? (
      clientesList.length > 0 ? (
        clientesList.map((cliente) => (
          <div key={cliente.clienteid} className="cliente-card">
            <div className="div-info">
              <div className="div-cliente-imagen">
                <img src={cliente.imagenurl} alt="equipo" className="imagen-cliente" />
                <SubirFotoCliente clienteId={cliente.clienteid} />
              </div>

              <div className="div-cliente-infocontainer">
                <div className="div-cliente-titulo">
                  <Link
                    to={`/dashboard/perfilcliente/${cliente.clienteid}`}
                    className="link_nombre_cliente"
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#03178C', mb: 0.5 }}>
                      {cliente.nombre}
                    </Typography>
                  </Link>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
                    {cliente.ciudad}
                  </Typography>
                </div>
                <Box className="div-cliente-info" sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  <Typography variant="body2" color="textSecondary"><strong>CC/NIT:</strong> {cliente.ccnit}</Typography>
                  <Typography variant="body2" color="textSecondary"><strong>Dirección:</strong> {cliente.direccion}</Typography>
                  <Typography variant="body2" color="textSecondary"><strong>Email:</strong> {cliente.email}</Typography>
                  <Typography variant="body2" color="textSecondary"><strong>Teléfono:</strong> {cliente.telefono}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Código REPS:</strong> {cliente.codigoreps ? cliente.codigoreps : 'No Registra'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Sede:</strong> {cliente.sede ? cliente.sede : 'No Registra'}
                  </Typography>
                </Box>
              </div>
            </div>

            <div className="div-acciones">
              <PlantillaConfig cliente={cliente} clienteId={cliente.clienteid} />
              <CargarFirmaCliente cliente={cliente} clienteId={cliente.clienteid} />
              <DetallesCliente cliente={cliente} clienteId={cliente.clienteid} />
              <div className="div-botoneliminarcliente">
                <Link to={`/dashboard/clientes/adminusers/${cliente.clienteid}`}>
                  <MyButton tip="Usuarios">
                    <FaUsers color="#03178C" className="icon-eliminarcliente" />
                  </MyButton>
                </Link>
              </div>
              <VerPerfil clienteId={cliente.clienteid} />
              <EliminarCliente clienteId={cliente.clienteid} />
            </div>
          </div>
        ))
      ) : (
        <div className="item-market-card">
          <div className="item-market-container">
            <div className="item-market-descripcion">
              {clientes.length === 0 && !hasQuery ? (
                <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4, mb: 4, fontWeight: 'bold' }}>
                  Añade un Prestador/Cliente para Empezar
                </Typography>
              ) : (
                <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4, mb: 4, fontWeight: 'bold' }}>
                  No hay clientes que coincidan con tu búsqueda
                </Typography>
              )}
            </div>
          </div>
        </div>
      )
    ) : (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress size={50} color="primary" />
      </Box>
    );

    return (
      <div>
        <Grid
          container
          spacing={2}
          className="clientes-toolbar"
          sx={{
            p: '5px',
            width: '95%',
            mx: 'auto',
            mb: 2,
            alignItems: 'center',
            boxSizing: 'border-box'
          }}
        >
          {/* Fila 1 (sm: ocupa toda la fila) */}
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              label={`Buscar por ${searchBy === 'ccnit' ? 'CC/NIT' : searchBy === 'ciudad' ? 'ciudad' : 'nombre'}`}
              placeholder={
                searchBy === 'ccnit'
                  ? 'Ej. 900123456-7'
                  : searchBy === 'ciudad'
                    ? 'Ej. Cali'
                    : 'Escribe el nombre del cliente…'
              }
              value={search}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>

          {/* Fila 2 (sm: tres columnas que suman 12) */}
          <Grid item xs={12} sm={5} md={5}>
            <FormControl size="small" fullWidth sx={{ minWidth: 160 }}>
              <InputLabel id="buscar-por-label">Buscar por</InputLabel>
              <Select
                labelId="buscar-por-label"
                id="buscar-por"
                value={searchBy}
                label="Buscar por"
                onChange={this.handleSearchByChange}
              >
                <MenuItem value="nombre">Nombre</MenuItem>
                <MenuItem value="ciudad">Ciudad</MenuItem>
                <MenuItem value="ccnit">CC/NIT</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={3} md={3}>
            <FormControl size="small" fullWidth sx={{ minWidth: 140 }}>
              <InputLabel id="orden-label">Orden</InputLabel>
              <Select
                labelId="orden-label"
                id="orden"
                value={sortOrder}
                label="Orden"
                onChange={this.handleSortOrderChange}
              >
                <MenuItem value="asc">A–Z</MenuItem>
                <MenuItem value="desc">Z–A</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4} md={4}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={this.handleClearFilters}
              startIcon={<ClearIcon />}
              aria-label="Borrar filtro"
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>

        {mapeoclientes}
      </div>
    );
  }
}

ListaClientes.propTypes = {
  getClientes: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  data: state.data
});

export default connect(mapStateToProps, { getClientes })(ListaClientes);
